export default __webpack_public_path__ + "static/media/Stryker_LateralDer.7712495c.webp";